import React, {useEffect} from 'react';
import {clearSelectedCart} from '../Store/CartSlice';
import {useDispatch} from "react-redux";
import { Button, Text } from '@fluentui/react-components';
import { CheckmarkCircleFilled } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';
import { useLocalization } from '../Components/Helpers/useLocalization';

const OrderCompletePage: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const L = useLocalization();

    useEffect(() => {
        dispatch(clearSelectedCart())
    }, [dispatch]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            textAlign: 'center',
            gap: '1rem',
            padding: '2rem',
        }}>
            <CheckmarkCircleFilled style={{ fontSize: '5rem', color: '#107c10' }} />
            <Text size={800} weight='bold'>{L('localization_order_complete_title')}</Text>
            <Text size={400}>{L('localization_order_complete_subtitle')}</Text>
            <Text size={300} style={{ color: '#666', maxWidth: '400px' }}>
                {L('localization_order_complete_email_notice')}
            </Text>
            <Button appearance='primary' onClick={() => navigate('/')}>{L('localization_order_complete_return_home')}</Button>
        </div>
    );
}

export default OrderCompletePage;